import styled from 'styled-components';
export const Wrapper = styled.div `
  max-height: 57.2rem;
  overflow-y: auto;
  .btn {
    margin-top: 0.5rem;
  }
`;
export const Header = styled.span `
  display: block;
  font: var(--heading-three-font);
`;
export const SubHeader = styled.span `
  display: block;
  font: var(--heading-four-font);
`;
export const IndividualMemberForm = styled.div `
  margin: 1.5rem 0;
`;
export default {
    Wrapper,
};
